import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import "../../../css/theme.css";
import InputField from "../../../component/input-field";
import SwitchInputField from "../../../component/switch-input-field";
import { useFormik, FieldArray, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { to_do_type_options } from "../../../utils";
import {
  Collaborator,
  Customer,
  Super_Admin,
  User,
} from "../../../constant/AuthenticationConstant";
import {
  getAllDepartmentByCompanyId,
  getUsersByDepartmentId,
  updateToDo,
  createToDo,
  getToDoById,
} from "../../../redux/actions/todo";
import { getCollaboratorOrCustomer } from "../../../redux/actions/collaboratorOrCustomer";
import {
  SAVE_TEMPORARY_DATA,
  RESET_SAVE_TEMPORARY_DATA,
  SET_RETAIN_PROPS,
} from "../../../redux/constants";
import { useNavigate, useLocation } from "react-router-dom";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { sanitizeInput } from "../../../utils/index";
import {
  SET_TODO_DATA_FOR_UPDATE_INVENTORY,
  CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY,
} from "../../../redux/constants";

function ToDoDetails({ setStep }) {
  // Assign navigation hook
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;

  // Getting data from the local storage
  const user = JSON.parse(localStorage.getItem("user"));
  const is_subscribed_inventory = user?.company?.is_subscribed_inventory;

  // Redux data
  const { type } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { saveData, tempPageName, stepNumber } = useSelector(
    (state) => state.tempWindowsData
  );
  const { newtododata, todoDataByToDoId } = useSelector((state) => state.todo);

  // State
  const [configs, setConfigs] = useState();
  const [allTeamsOptions, setAllTeamsOptions] = useState();
  const [user_or_collaborator_options, setUser_or_collaborator_options] =
    useState();
  const [toDoTypeValue, setToDoTypeValue] = useState();
  const [responsibleTeamValue, setResponsibleTeamValue] = useState();
  const [responsibleUserValue, setResponsibleUserValue] = useState();
  const [uploadFileData, setUploadFileData] = useState(
    state || newtododata
      ? [
          {
            activity_id: state ? state.id : newtododata,
            file_name: "",
            is_mandatory: false,
          },
        ]
      : [
          {
            file_name: "",
            is_mandatory: false,
          },
        ]
  );

  const [to_do_details, setTo_do_details] = useState({
    to_do_name: "",
    to_do_description: "",
    to_do_type: "",
    to_do_label: "",
    resposible_team: "",
    responsible_user: "",
    is_mandatory_extension: false,
    is_sku_increased: true,
  });

  // Setting formik an dyup validation for upload file field validation
  const fileValidationSchema = Yup.object().shape({
    fileData: Yup.array().of(
      Yup.object().shape({
        file_name: Yup.string().required("This field is required"),
        is_mandatory: Yup.boolean(),
      })
    ),
  });

  const fileFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fileData: uploadFileData,
    },
    validationSchema: fileValidationSchema,
    onSubmit: (value) => {
      formik.handleSubmit();
    },
  });

  // Setting formik and yup for form validation
  const validationSchema = Yup.object().shape({
    to_do_name: Yup.string().required("This field is required"),
    to_do_description: Yup.string(),
    to_do_type: Yup.string().required("This field is required"),
    to_do_label: Yup.string().nullable(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: to_do_details,
    validationSchema,
    onSubmit: (values) => {
      handleNext();
    },
  });

  // useEffect to reset the fileFormik when upload document toggle gets false
  useEffect(() => {
    if (configs && !configs[2].checked) {
      setUploadFileData(
        state || newtododata
          ? [
              {
                activity_id: state ? state.id : newtododata,
                file_name: "",
                is_mandatory: false,
              },
            ]
          : [
              {
                file_name: "",
                is_mandatory: false,
              },
            ]
      );
      fileFormik.resetForm();
    }
  }, [configs]);

  // Function to call the create new To Do API
  const handleNext = () => {
    const payload = {
      name: formik.values.to_do_name.trim(),
      description: formik.values.to_do_description.trim(),
      based_on: formik.values.to_do_type,
      label: formik.values.to_do_label,
      department:
        !formik.values.resposible_team ||
        formik.values.resposible_team === Customer ||
        formik.values.resposible_team === Collaborator
          ? null
          : formik.values.resposible_team,
      user:
        !formik.values.responsible_user ||
        formik.values.resposible_team === Customer ||
        formik.values.resposible_team === Collaborator
          ? null
          : formik.values.responsible_user,
      emoji: "",
      compulsory: false,
      mandatory_upload: fileFormik.values.fileData[0].file_name
        ? fileFormik.values.fileData
        : [],
      validation_api_id: null,
      id: state ? state.id : newtododata ? newtododata : null,
      asset_entry: configs[0]?.checked,
      asset_url: "",
      is_upload_allowed: configs[2]?.checked,
      isvalidation: false,
      is_extensible: configs[3]?.checked,
      allow_user_edit: configs[4]?.checked,
      mandatory_extension_request: formik.values.is_mandatory_extension,
      remarks: "1",
      is_trackable: configs[1]?.checked,
      is_assign_to_customer:
        formik.values.resposible_team === Customer ? true : false,
      collaborator_id:
        formik.values.resposible_team === Collaborator &&
        formik.values.responsible_user
          ? formik.values.responsible_user.trim()
          : null,
      change_inventory: configs[5]?.checked,
    };

    dispatch({
      type: SET_TODO_DATA_FOR_UPDATE_INVENTORY,
      payload: payload.change_inventory,
    });

    if (state || newtododata) {
      dispatch(
        updateToDo(payload, (res) => {
          if (res.status === 1) {
            setStep(2);
          } else {
            swal({
              content: (
                <CustomeModal
                  type="error"
                  title="Error!"
                  content={
                    res.message === "Duplicate entry"
                      ? "This todo name is already used, try another name"
                      : res.message
                  }
                />
              ),
              buttons: false,
              closeOnClickOutside: false,
              closeOnEsc: false,
            });
          }
        })
      );
    } else {
      dispatch(
        createToDo(payload, (res) => {
          if (res.status === 1) {
            setStep(2);
            if (tempPageName === "manage todo") {
              dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
            }
          } else {
            swal({
              content: (
                <CustomeModal
                  type="error"
                  title="Error!"
                  content={
                    res.message === "Duplicate entry"
                      ? "This todo name is already used, try another name"
                      : res.message
                  }
                />
              ),
              buttons: false,
              closeOnClickOutside: false,
              closeOnEsc: false,
            });
          }
        })
      );
    }

    // if (tempPageName === "manage todo") {
    //   dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
    // }
  };

  // Function to change To Do Advanced Configuration
  const handleCheck = (index) => {
    const newConfigs = [...configs];
    newConfigs[index].checked = !newConfigs[index].checked;
    setConfigs(newConfigs);
  };

  // Function to save data if navigate to other page
  const handleNavigation = (type) => {
    const payload = {
      path: location.pathname,
      tempPageName: "manage todo",
      saveData: {
        data: formik.values,
        configs,
        filedata: fileFormik.values.fileData,
      },
    };

    dispatch({ type: SAVE_TEMPORARY_DATA, payload });

    if (type === "department") {
      navigate("/departments");
    } else if (type === Collaborator) {
      navigate("/users", { state: 2 });
    } else {
      navigate("/users");
    }
  };

  // Function to show Add New Team and Add New User in dropdown option
  const { MenuList } = components;
  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      <div
        className="menu-list"
        onClick={(e) => {
          e.stopPropagation();
          handleNavigation(props.selectProps.name);
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        {props.selectProps.name === "resposible_team"
          ? "Create New Team"
          : props.selectProps.name === Collaborator
          ? "Create New Collaborator"
          : "Create New User"}
      </div>
    </MenuList>
  );

  // Function to get Team List
  const getTeam = () => {
    dispatch(
      getAllDepartmentByCompanyId((res) => {
        if (res.status === 1) {
          const result = res.data;
          const teamsArray = result.map((team) => {
            return { value: team.id, label: team.name, name: "department" };
          });
          let departmentOptions = [
            {
              label: "Collaborator",
              value: Collaborator,
            },
            {
              label: "Customer",
              value: Customer,
            },
            {
              label: "Internal Teams",
              options: teamsArray,
            },
          ];
          setAllTeamsOptions(departmentOptions);
        }
      })
    );
  };

  // Function to get user list on the basis of team
  const getUserList = () => {
    dispatch(
      getUsersByDepartmentId(responsibleTeamValue?.value, (res) => {
        if (res.status === 1) {
          const users = res.data.map((item) => {
            return { value: item.id, label: item.name, name: "user" };
          });
          setUser_or_collaborator_options(users);
        }
      })
    );
  };

  // useEffect to set the user or collaborator data.
  useEffect(() => {
    if (todoDataByToDoId && user_or_collaborator_options) {
      if (saveData?.data?.responsible_user) {
        const filtered_responsible_user = user_or_collaborator_options.find(
          (element) => element.value === saveData.data.responsible_user
        );
        filtered_responsible_user
          ? setResponsibleUserValue(filtered_responsible_user)
          : setResponsibleUserValue(null);
      } else if (state || newtododata) {
        const filtered_responsible_user = user_or_collaborator_options.find(
          (element) =>
            element.value === todoDataByToDoId.user ||
            element.value === todoDataByToDoId.collaborator_id
        );
        filtered_responsible_user
          ? setResponsibleUserValue(filtered_responsible_user)
          : setResponsibleUserValue(null);
      }
    }
  }, [user_or_collaborator_options]);

  // Function to get To Do data by id
  const getToDoDataById = () => {
    if (state || newtododata) {
      dispatch(
        getToDoById(state ? state.id : newtododata, (res) => {
          let result = res.data;
          setUpdateData(result);
        })
      );
    }
  };

  // Function to get collaborator list
  const collaboratorList = () => {
    dispatch(
      getCollaboratorOrCustomer(Collaborator, (res) => {
        if (res.status === 1) {
          const users = res.data.data.map((item) => {
            return {
              value: item.collaborator_id,
              label: item.name,
              name: "user",
            };
          });
          setUser_or_collaborator_options(users);
        }
      })
    );
  };

  useEffect(() => {
    getTeam();
    setConfigs([
      {
        title: "Allow Asset Entry",
        description: "Allow the Entry of Assets in this Task.",
        checked: state ? state.asset_entry : false,
      },
      {
        title: "Allow Customers to Track This To Do",
        description:
          "If activated customers are able to see the progress of this to do for their bookings.",
        checked: state ? Boolean(Number(state.is_trackable)) : false,
      },
      {
        title: "Upload File",
        description: "Allow the Upload of Files.",
        checked: state ? Boolean(Number(state?.is_upload_allowed)) : false,
      },
      {
        title: "Extension",
        description: "Allow the Users to Request for Extension.",
        checked: state ? Boolean(Number(state?.is_extensible)) : false,
      },
      {
        title: "Allow User Edit",
        description: "Allow Users to Edit Activity Performance.",
        checked: state ? state?.allow_user_edit : false,
      },
      {
        title: "Update Inventory",
        description:
          "If activated this to do will have an impact on the inventory levels.",
        checked: state ? Boolean(state?.change_inventory) : false,
      },
    ]);
  }, []);

  useEffect(() => {
    if (responsibleTeamValue && responsibleTeamValue?.name) {
      getUserList();
    } else if (
      responsibleTeamValue &&
      responsibleTeamValue.value === Collaborator
    ) {
      collaboratorList();
    } else {
      setUser_or_collaborator_options([]);
    }
  }, [responsibleTeamValue]);

  // Function to store saved data
  const setSavedData = () => {
    setTo_do_details(saveData.data);
    setUploadFileData(saveData.filedata);
    setConfigs(saveData.configs);

    const filtered_to_do_typed = to_do_type_options.find(
      (element) => element.value === saveData.data.to_do_type
    );
    if (filtered_to_do_typed) {
      setToDoTypeValue(filtered_to_do_typed);
    }

    let filtered_responsible_team;
    if (saveData.data.resposible_team === Customer) {
      filtered_responsible_team = allTeamsOptions[1];
    } else if (saveData.data.resposible_team === Collaborator) {
      filtered_responsible_team = allTeamsOptions[0];
    } else {
      filtered_responsible_team = allTeamsOptions[2].options.find(
        (element) => element.value === saveData.data.resposible_team
      );
    }
    setResponsibleTeamValue(filtered_responsible_team);
  };

  // Function to store data if user want to edit it
  const setUpdateData = (resultData) => {
    if (resultData && allTeamsOptions?.length > 0) {
      setTo_do_details({
        to_do_name: resultData ? resultData.name : "",
        to_do_description: resultData ? resultData.description : "",
        to_do_type: resultData ? resultData.based_on : "",
        to_do_label: resultData ? resultData.label : "",
        resposible_team: resultData
          ? resultData.is_assign_to_customer
            ? Customer
            : resultData.collaborator_id
            ? Collaborator
            : resultData.department
            ? resultData.department
            : ""
          : "",
        responsible_user: resultData
          ? resultData.collaborator_id
            ? resultData.collaborator_id
            : resultData.user
            ? resultData.user
            : ""
          : "",
        is_mandatory_extension: resultData
          ? resultData?.mandatory_extension_request
          : false,
        is_sku_increased: resultData
          ? resultData?.change_inventory === "increase_sku"
            ? true
            : false
          : true,
      });

      setConfigs([
        {
          title: "Allow Asset Entry",
          description: "Allow the Entry of Assets in this Task.",
          checked: resultData ? resultData.asset_entry : false,
        },
        {
          title: "Allow Customers to Track This To Do",
          description:
            "If activated customers are able to see the progress of this to do for their bookings.",
          checked: resultData
            ? Boolean(Number(resultData.is_trackable))
            : false,
        },
        {
          title: "Upload File",
          description: "Allow the Upload of Files.",
          checked: resultData
            ? Boolean(Number(resultData?.is_upload_allowed))
            : false,
        },
        {
          title: "Extension",
          description: "Allow the Users to Request for Extension.",
          checked: resultData
            ? Boolean(Number(resultData?.is_extensible))
            : false,
        },
        {
          title: "Allow User Edit",
          description: "Allow Users to Edit Activity Performance.",
          checked: resultData ? resultData?.allow_user_edit : false,
        },
        {
          title: "Update Inventory",
          description:
            "If activated this to do will have an impact on the inventory levels.",
          checked: resultData ? Boolean(resultData?.change_inventory) : false,
        },
      ]);

      const filtered_to_do_typed = to_do_type_options.find(
        (element) => element.value === resultData.based_on
      );

      let filtered_responsible_team;

      if (resultData.department) {
        filtered_responsible_team = allTeamsOptions[2].options.find(
          (element) => element.value === resultData.department
        );
      } else if (resultData.is_assign_to_customer) {
        filtered_responsible_team = allTeamsOptions[1];
      } else if (resultData.collaborator_id) {
        filtered_responsible_team = allTeamsOptions[0];
      } else {
        filtered_responsible_team = "";
      }

      setResponsibleTeamValue(filtered_responsible_team);
      setToDoTypeValue(filtered_to_do_typed);

      if (resultData.activity_file_uploads.length > 0) {
        const filtered_upload_file = resultData.activity_file_uploads.map(
          (element) => ({
            file_name: element.file_name,
            is_mandatory: element.is_mandatory,
            activity_file_upload_id: element.activity_file_upload_id,
            activity_id: resultData.id,
          })
        );
        setUploadFileData(filtered_upload_file);
      }
    }
  };

  useEffect(() => {
    if (
      Object.keys(saveData).length > 0 &&
      allTeamsOptions &&
      saveData?.configs
    ) {
      setSavedData();
    } else if (allTeamsOptions) {
      getToDoDataById();
    }
  }, [allTeamsOptions, saveData]);

  return (
    <div
      className="relative py-4 h-screen space-y-4"
      style={{ maxHeight: "calc(100vh - 138px)" }}
    >
      <div className="rounded-md bg-[--bg-color-50] p-5 space-y-4">
        <h4 className="text-base font-bold leading-5 text-[#535860]">
          To Do Details
        </h4>
        <div
          className={`grid grid-cols-1 ${
            toDoTypeValue?.value === "Document"
              ? "sm:grid-cols-4"
              : "sm:grid-cols-3"
          }  gap-4`}
        >
          <InputField
            type="text"
            label="To Do Name"
            wrapperClass="w-full"
            placeholder="To Do Name"
            name="to_do_name"
            value={formik.values.to_do_name}
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              formik.setFieldValue("to_do_name", value);
            }}
            onBlur={formik.handleBlur}
            error={
              Boolean(formik.touched.to_do_name && formik.errors.to_do_name)
                ? formik.errors.to_do_name
                : null
            }
            required
          />
          <InputField
            type="text"
            label="To Do Description"
            wrapperClass="w-full"
            placeholder="To Do Description"
            name="to_do_description"
            value={formik.values.to_do_description}
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              formik.setFieldValue("to_do_description", value);
            }}
            disabled={state?.master_activity?.is_immutable}
          />
          <div className="w-full">
            <div className="flex items-center justify-between">
              <label
                className={`block text-sm font-medium mb-1 w-2/3 overflow-hidden`}
              >
                To Do Type
                <span className="text-rose-500">&nbsp;*</span>
              </label>
            </div>

            <div className="relative">
              <Select
                options={to_do_type_options}
                isClearable={true}
                menuPortalTarget={document.body}
                className="basic-single text-sm unresetText"
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "#9B9B9B", // Set your desired color here
                    fontSize: "14px",
                  }),
                }}
                placeholder="Select To Do Type"
                menuPlacement="auto"
                name="to_do_type"
                value={toDoTypeValue}
                onChange={(type) => {
                  formik.setFieldValue("to_do_type", type?.value);
                  setToDoTypeValue(type);
                }}
                isDisabled={state?.master_activity?.is_immutable}
              />
              {Boolean(
                formik.touched.to_do_type && formik.errors.to_do_type
              ) ? (
                <p className="text-xs text-rose-500 text-left">
                  {`${formik.errors.to_do_type}!`}
                </p>
              ) : null}
            </div>
          </div>
          {toDoTypeValue?.value === "Document" && (
            <InputField
              type="text"
              label="Label"
              wrapperClass="w-full"
              placeholder="Enter Label"
              name="to_do_label"
              value={formik.values.to_do_label}
              onChange={(e) => {
                const value = sanitizeInput(e.target.value);
                formik.setFieldValue("to_do_label", value);
              }}
              disabled={state?.master_activity?.is_immutable}
            />
          )}
        </div>
        {/* <div className="grid grid-cols-2 gap-4">
          <div className="w-full">
            <div className="flex items-center justify-between">
              <label
                className={`block text-sm font-medium mb-1 w-2/3 overflow-hidden`}
              >
                Responsible Team
              </label>
            </div>

            <div className="relative">
              <Select
                options={allTeamsOptions}
                isClearable={true}
                menuPortalTarget={document.body}
                className="basic-single text-sm unresetText"
                classNames={{
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]/50"
                        : "!border-slate-200 hover:!border-gray-300"
                    }`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
                name="resposible_team"
                value={responsibleTeamValue}
                onChange={(team) => {
                  setResponsibleUserValue(null);
                  formik.setFieldValue("responsible_user", "");
                  formik.setFieldValue("resposible_team", team?.value);
                  setResponsibleTeamValue(team);
                }}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "#9B9B9B", // Set your desired color here
                    fontSize: "14px",
                  }),
                }}
                placeholder="Select Team"
                menuPlacement="auto"
                components={
                  type === Super_Admin ? { MenuList: CustomMenuList } : {}
                }
                isDisabled={state?.master_activity?.is_immutable}
                // required
              />
              {Boolean(
                formik.touched.resposible_team && formik.errors.resposible_team
              ) ? (
                <p className="text-xs text-rose-500 text-left">
                  {`${formik.errors.resposible_team}!`}
                </p>
              ) : null}
            </div>
          </div>
          <div className="w-full">
            <div className="flex items-center justify-between">
              <label
                className={`block text-sm font-medium mb-1 w-2/3 overflow-hidden`}
              >
                Responsible User
              </label>
            </div>

            <div className="relative">
              <Select
                options={user_or_collaborator_options}
                isClearable={true}
                isDisabled={
                  formik.values.resposible_team === Customer ||
                  state?.master_activity?.is_immutable
                }
                menuPortalTarget={document.body}
                className="basic-single text-sm unresetText"
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "#9B9B9B", // Set your desired color here
                    fontSize: "14px",
                  }),
                }}
                placeholder="Select User"
                menuPlacement="auto"
                name={
                  responsibleTeamValue?.value === Collaborator
                    ? Collaborator
                    : User
                }
                value={responsibleUserValue}
                onChange={(user) => {
                  setResponsibleUserValue(user);
                  formik.setFieldValue("responsible_user", user?.value);
                }}
                components={
                  type === Super_Admin ? { MenuList: CustomMenuList } : {}
                }
                required
              />
            </div>
          </div>
        </div> */}
      </div>
      <div className="rounded-md bg-[--bg-color-50] p-5 space-y-4">
        <h4 className="text-base font-bold leading-5 text-[#535860]">
          Advanced Configurations
        </h4>
        <div className="grid grid-cols-2 gap-4">
          {configs &&
            configs.map((field, index) => {
              return (
                <div className="bg-white rounded-md">
                  {is_subscribed_inventory ? (
                    <SwitchInputField
                      key={index}
                      tag="div"
                      tagClass="p-2"
                      index={index}
                      title={field.title}
                      description={field.description}
                      checked={field.checked}
                      onCheck={() => handleCheck(index)}
                      disabled={
                        field.title === "Allow Customers to Track This To Do"
                          ? false
                          : state?.master_activity?.is_immutable
                      }
                      content={
                        index === 2
                          ? field.checked && (
                              <div className="flex-1 mt-5">
                                <FormikProvider value={fileFormik}>
                                  <Form autoComplete="off" noValidate>
                                    <FieldArray
                                      name="fileData"
                                      render={(arrayHelpers) => (
                                        <>
                                          {fileFormik.values.fileData.map(
                                            (row, index) => {
                                              return (
                                                <>
                                                  {index === 0 && (
                                                    <label
                                                      className="block text-sm font-medium mb-1"
                                                      htmlFor="file-name"
                                                    >
                                                      File Name
                                                      <span className="text-rose-500">
                                                        &nbsp;*
                                                      </span>
                                                    </label>
                                                  )}
                                                  <div className="flex items-baseline space-x-8 mt-2">
                                                    <InputField
                                                      type="text"
                                                      wrapperClass="w-1/2"
                                                      placeholder="Enter File Name"
                                                      name="file_name"
                                                      onChange={(event) => {
                                                        const value =
                                                          sanitizeInput(
                                                            event.target.value
                                                          );
                                                        fileFormik.setFieldValue(
                                                          `fileData[${index}].file_name`,
                                                          value
                                                        );
                                                      }}
                                                      value={row.file_name}
                                                      onBlur={
                                                        fileFormik.handleBlur
                                                      }
                                                      disabled={
                                                        state?.master_activity
                                                          ?.is_immutable
                                                      }
                                                      error={
                                                        Boolean(
                                                          fileFormik.touched &&
                                                            fileFormik.touched
                                                              .fileData &&
                                                            fileFormik.touched
                                                              .fileData[
                                                              index
                                                            ] &&
                                                            fileFormik.touched
                                                              .fileData[index]
                                                              .file_name &&
                                                            fileFormik.errors &&
                                                            fileFormik.errors
                                                              .fileData &&
                                                            fileFormik.errors
                                                              .fileData[
                                                              index
                                                            ] &&
                                                            fileFormik.errors
                                                              .fileData[index]
                                                              .file_name
                                                        )
                                                          ? fileFormik.errors
                                                              .fileData[index]
                                                              .file_name
                                                          : null
                                                      }
                                                    />
                                                    <span className="space-x-2">
                                                      <input
                                                        name="is_mandatory"
                                                        id={`is_mandatory-${index}`}
                                                        type="checkbox"
                                                        onChange={(e) =>
                                                          fileFormik.setFieldValue(
                                                            `fileData[${index}].is_mandatory`,
                                                            e.target.checked
                                                          )
                                                        }
                                                        className="form-checkbox text-sm"
                                                        checked={
                                                          row.is_mandatory
                                                        }
                                                        disabled={
                                                          state?.master_activity
                                                            ?.is_immutable
                                                        }
                                                      />
                                                      <label
                                                        htmlFor={`is_mandatory-${index}`}
                                                        className="text-sm cursor-pointer"
                                                      >
                                                        Mandatory Upload
                                                      </label>
                                                    </span>
                                                    {index !== 0 && (
                                                      <span
                                                        title="Delete"
                                                        className={`fa-regular fa-trash-can text-sm cursor-pointer text-rose-500 ${
                                                          state?.master_activity
                                                            ?.is_immutable &&
                                                          "pointer-events-none"
                                                        }`}
                                                        onClick={(e) =>
                                                          arrayHelpers.remove(
                                                            index
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                </>
                                              );
                                            }
                                          )}
                                          <h6
                                            className={`text-xs font-semibold leading-3 tracking-tight text-[--bg-color-500] cursor-pointer my-2`}
                                            onClick={() => {
                                              const obj = {
                                                file_name: "",
                                                is_mandatory: false,
                                              };
                                              if (state || newtododata) {
                                                obj.activity_id = state
                                                  ? state.id
                                                  : newtododata;
                                              }
                                              arrayHelpers.push(obj);
                                            }}
                                          >
                                            + Add Item
                                          </h6>
                                        </>
                                      )}
                                    />
                                  </Form>
                                </FormikProvider>
                              </div>
                            )
                          : index == 3
                          ? field.checked && (
                              <div className="py-4">
                                <SwitchInputField
                                  title="Mandatory Extension Request"
                                  tagClass="border-slate-200"
                                  content=""
                                  description="Make an extension request mandatory for the assigned user if the to do is overdue."
                                  name="compulsary"
                                  checked={formik.values.is_mandatory_extension}
                                  onCheck={(e) => {
                                    formik.setFieldValue(
                                      "is_mandatory_extension",
                                      e.target.checked
                                    );
                                  }}
                                />
                              </div>
                            )
                          : field.checked
                      }
                    />
                  ) : (
                    field.title !== "Update Inventory" && (
                      <SwitchInputField
                        key={index}
                        tag="div"
                        tagClass="p-2"
                        index={index}
                        title={field.title}
                        description={field.description}
                        checked={field.checked}
                        onCheck={() => handleCheck(index)}
                        disabled={
                          field.title === "Allow Customers to Track This To Do"
                            ? false
                            : state?.master_activity?.is_immutable
                        }
                        content={
                          index === 2
                            ? field.checked && (
                                <div className="flex-1 mt-5">
                                  <FormikProvider value={fileFormik}>
                                    <Form autoComplete="off" noValidate>
                                      <FieldArray
                                        name="fileData"
                                        render={(arrayHelpers) => (
                                          <>
                                            {fileFormik.values.fileData.map(
                                              (row, index) => {
                                                return (
                                                  <>
                                                    {index === 0 && (
                                                      <label
                                                        className="block text-sm font-medium mb-1"
                                                        htmlFor="file-name"
                                                      >
                                                        File Name
                                                        <span className="text-rose-500">
                                                          &nbsp;*
                                                        </span>
                                                      </label>
                                                    )}
                                                    <div className="flex items-baseline space-x-8 mt-2">
                                                      <InputField
                                                        type="text"
                                                        wrapperClass="w-1/2"
                                                        placeholder="Enter File Name"
                                                        name="file_name"
                                                        onChange={(event) => {
                                                          const value =
                                                            sanitizeInput(
                                                              event.target.value
                                                            );
                                                          fileFormik.setFieldValue(
                                                            `fileData[${index}].file_name`,
                                                            value
                                                          );
                                                        }}
                                                        value={row.file_name}
                                                        onBlur={
                                                          fileFormik.handleBlur
                                                        }
                                                        disabled={
                                                          state?.master_activity
                                                            ?.is_immutable
                                                        }
                                                        error={
                                                          Boolean(
                                                            fileFormik.touched &&
                                                              fileFormik.touched
                                                                .fileData &&
                                                              fileFormik.touched
                                                                .fileData[
                                                                index
                                                              ] &&
                                                              fileFormik.touched
                                                                .fileData[index]
                                                                .file_name &&
                                                              fileFormik.errors &&
                                                              fileFormik.errors
                                                                .fileData &&
                                                              fileFormik.errors
                                                                .fileData[
                                                                index
                                                              ] &&
                                                              fileFormik.errors
                                                                .fileData[index]
                                                                .file_name
                                                          )
                                                            ? fileFormik.errors
                                                                .fileData[index]
                                                                .file_name
                                                            : null
                                                        }
                                                      />
                                                      <span className="space-x-2">
                                                        <input
                                                          name="is_mandatory"
                                                          id={`is_mandatory-${index}`}
                                                          type="checkbox"
                                                          onChange={(e) =>
                                                            fileFormik.setFieldValue(
                                                              `fileData[${index}].is_mandatory`,
                                                              e.target.checked
                                                            )
                                                          }
                                                          className="form-checkbox text-sm"
                                                          checked={
                                                            row.is_mandatory
                                                          }
                                                          disabled={
                                                            state
                                                              ?.master_activity
                                                              ?.is_immutable
                                                          }
                                                        />
                                                        <label
                                                          htmlFor={`is_mandatory-${index}`}
                                                          className="text-sm cursor-pointer"
                                                        >
                                                          Mandatory Upload
                                                        </label>
                                                      </span>
                                                      {index !== 0 && (
                                                        <span
                                                          title="Delete"
                                                          className={`fa-regular fa-trash-can text-sm cursor-pointer text-rose-500 ${
                                                            state
                                                              ?.master_activity
                                                              ?.is_immutable &&
                                                            "pointer-events-none"
                                                          }`}
                                                          onClick={(e) =>
                                                            arrayHelpers.remove(
                                                              index
                                                            )
                                                          }
                                                        />
                                                      )}
                                                    </div>
                                                  </>
                                                );
                                              }
                                            )}
                                            <h6
                                              className={`text-xs font-semibold leading-3 tracking-tight text-[--bg-color-500] cursor-pointer my-2`}
                                              onClick={() => {
                                                const obj = {
                                                  file_name: "",
                                                  is_mandatory: false,
                                                };
                                                if (state || newtododata) {
                                                  obj.activity_id = state
                                                    ? state.id
                                                    : newtododata;
                                                }
                                                arrayHelpers.push(obj);
                                              }}
                                            >
                                              + Add Item
                                            </h6>
                                          </>
                                        )}
                                      />
                                    </Form>
                                  </FormikProvider>
                                </div>
                              )
                            : index == 3
                            ? field.checked && (
                                <div className="py-4">
                                  <SwitchInputField
                                    title="Mandatory Extension Request"
                                    tagClass="border-slate-200"
                                    content=""
                                    description="Make an extension request mandatory for the assigned user if the to do is overdue."
                                    name="compulsary"
                                    checked={
                                      formik.values.is_mandatory_extension
                                    }
                                    onCheck={(e) => {
                                      formik.setFieldValue(
                                        "is_mandatory_extension",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                </div>
                              )
                            : field.checked
                        }
                      />
                    )
                  )}
                </div>
              );
            })}
        </div>
      </div>
      <div className={`w-full flex item-center justify-between`}>
        <button
          className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
          onClick={() => {
            if (tempPageName === "manage todo") {
              dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
            }
            dispatch({ type: SET_RETAIN_PROPS, payload: false });
            navigate("/activity/overview");
          }}
        >
          Cancel
        </button>

        <div className="space-x-4">
          <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            onClick={() => {
              if (tempPageName === "manage todo") {
                dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
              }
              dispatch({ type: SET_RETAIN_PROPS, payload: false });
              navigate("/activity/overview");
            }}
          >
            Back
          </button>
          <button
            type="submit"
            className="btn !bg-[--bg-color-500] !hover:bg-[--bg-color-600] text-white cursor-pointer"
            onClick={() => {
              if (configs[2].checked) {
                fileFormik.handleSubmit();
              } else {
                formik.handleSubmit();
              }
            }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default ToDoDetails;
